<div
  class="tw-flex tw-flex-col tw-col-span-2 xl:tw-col-span-1 tw-h-full tw-justify-end tw-w-full tw-text-dark-light-dynamic">
  <div class="charts-actions tw-flex tw-items-center tw-justify-end tw-mt-4 xl:tw-mt-0 tw-mb-2">
    <app-option-toggle
      label="Last 3 Months:"
      [options]="movementTypeOptions"
      [selectedValue]="movementType"
      (selectionChange)="onMovementTypeChanged($event)">
    </app-option-toggle>
  </div>
  <div
    id="people-grid"
    class="tw-rounded tw-w-full tw-h-full tw-min-h-[400px]"
    [class.mat-card-shadow]="boxShadow">
    <ag-grid-angular
      style="height: 100%; width: 100%"
      [ngClass]="{ 'ag-theme-balham': !(darkModeService.darkMode$ | async), 'ag-theme-balham-dark': darkModeService.darkMode$ | async }"
      [rowData]="rowData"
      [columnDefs]="columnDefs"
      [rowModelType]="rowModelType"
      [defaultColDef]="defaultColDef"
      [getRowId]="getRowId"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      enableCellTextSelection="true"
      (gridReady)="onGridReady($event)"
      (rowClicked)="onRowClicked($event)"
      [serverSideDatasource]="serverSideDatasource">
    </ag-grid-angular>
  </div>

  <div class="tw-flex tw-justify-center tw-mt-2 tw-mb-0 tw-w-full">
    <a
      *ngIf="quickBuild"
      href="javascript:void(0)"
      (click)="onViewPeopleClicked()"
      class="tw-font-sm  tw-text-dynamic-text-color hover:tw-underline tw-inline-block">
      View People Details
    </a>
  </div>
</div>
